import React, { useState } from "react";
import mainBackground from "../../assets/images/mostChargerGet/the_rich_hole_title_banner.gif";
import data from "../../assets/images/mostChargerGet/the_rich_hall_user_frame.png";
import conis from "../../assets/images/mostChargerGet/the_rich_hall_id.png";
import ring from "../../assets/images/mostChargerGet/the_rich_hall_lion1.png";
import fallbackImage from "../../assets/icons/selected_male.png";

import { useTranslation } from "react-i18next";
const Design = ({ weeklyData1 }) => {
  const { t } = useTranslation();
  const [imageErrors, setImageErrors] = useState({});

  // Handle image error by updating the imageErrors state
  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true, // Mark this item image as failed to load
    }));
  };
  return (
    <div className="bg-black overflow-hidden">
      <div className="MostCharger ">
        <div className="relative h-[34%] w-full ">
          <img src={mainBackground} alt="parent-img" className="" />
          <p className="relative w-fit top-[-9.2rem] left-[38%] font-bold  text-[#fff77f] text-xl">
            صالة الاثرياء
          </p>
        </div>
        <div className=" relative ">
          <img
            src={data}
            alt="parent-img"
            className=" w-40 z-50 mx-auto relative"
          />{" "}
          <img
            src={
              imageErrors[weeklyData1?.user_image] // Check if this image has an error
                ? fallbackImage
                : `https://storage.googleapis.com/top-star-bucket/${weeklyData1?.user_image}`
            }
            onError={() => handleError(weeklyData1?.user_image)} // Handle error for individual image
            alt={weeklyData1?.user_image}
            className="w-[100px] [100px] absolute left-[37%] z-0 top-9 rounded-full mx-auto " // Adjust class for proper positioning
          />
        </div>{" "}
        <div className=" relative ">
          <img
            src={conis}
            alt="parent-img"
            className=" w-48 h-16  mx-auto relative"
          />{" "}
          <p className="relative w-fit top-[-3.3rem] left-[32%] font-bold text-[#000] text-lg">
            {t("User Id")} : {weeklyData1?.user_uuid}
          </p>
        </div>{" "}
        <div className=" relative -top-10">
          <img src={ring} alt="parent-img" className="" />{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};

export default Design;
